import React, { useEffect, useState } from 'react';
import {
  ScheduleComponent,
  Day,
  Week,
  WorkWeek,
  Month,
  Inject,
} from '@syncfusion/ej2-react-schedule';
import { registerLicense } from '@syncfusion/ej2-base';
import { BaseUrl } from '../../../Actions/Base';
import "./AllLearnersScheduleView.css";

registerLicense('ORg4AjUWIQA/Gnt2XFhhQlJHfVhdWHxLflFzVWBTfV56dFdWACFaRnZdR11lSXtSc0dkWH5bcn1cTWJV');

const AllLearnersSchedulerView = ({ InstituteAllStudentsSchedule }) => {
  const [events, setEvents] = useState([]);
  const [scheduleWidth, setScheduleWidth] = useState('1200px');

  useEffect(() => {
    const updateWidth = () => {
      const screenWidth = window.innerWidth;
      setScheduleWidth(screenWidth > 1700 ? '1500px' : '1200px');
    };

    updateWidth(); // set on initial load
    window.addEventListener('resize', updateWidth);

    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  useEffect(() => {
    if (!InstituteAllStudentsSchedule?.length) return;

    const classTypeColors = {
      Driving: '#0AA63014',
      Online:  '#FC000014',
      InClass: '#5298F514',
    };

    const classAboveBorderColors = {
      Driving: '#0AA630',
      Online:  '#FC0000',
      InClass: '#5298F5',
    };

    const transformed = InstituteAllStudentsSchedule.map((entry) => {
      const schedule = entry.ClassSchedule;
      const instructor = entry.Instructor || {};
      const student = entry.Student || {};

      return {
        Id: entry.EnrollmentId,
        Subject: `${schedule.ClassType}`,
        StartTime: new Date(schedule.startDate),
        EndTime: new Date(schedule.endDate),
        InstructorName: `${instructor.FirstName || ''} ${instructor.LastName || ''}`,
        InstructorImage: instructor.ProfileImage || '',
        StudentName: `${student.FirstName || ''} ${student.LastName || ''}`,
        StudentImage: student.ProfileImage || '',
        CategoryColor: classTypeColors[schedule.ClassType] || '#999999',
        CategoryColorBorder: classAboveBorderColors[schedule.ClassType] || '#999999',
      };
    });

    setEvents(transformed);
  }, [InstituteAllStudentsSchedule]);

  useEffect(() => {
    console.log("✅ Updated events:", events);
  }, [events]);


  const onEventRendered = (args) => {
    const eventColor = args.data.CategoryColor || '#FF52C5';
    args.element.style.backgroundColor = eventColor;
    args.element.style.borderTopLeftRadius = '0px';
    args.element.style.borderTopRightRadius = '0px';
    args.element.style.borderBottomLeftRadius = '5px';
    args.element.style.borderBottomRightRadius = '5px';
    args.element.style.color = 'white';
  };

  const eventTemplate = (props) => {
    return (
      <>
        <div className="w-full flex flex-col text-[#000000]">
            <div className='w-full h-[5px]' style={{ backgroundColor: props.CategoryColorBorder }}></div>
            <div className='px-1 w-full flex items-center gap-[5px]'>
                <img className="w-[20px] h-[20px] rounded-full"
                 src={`${BaseUrl}/api/images/Instructors?url=${props.InstructorImage}`}
                 alt="" />
                <p className="text-[14px] font-bold">{props.InstructorName}</p>
            </div>
            <div className='px-1 w-full flex items-center justify-end gap-[5px]'>
                <p className="text-[14px] font-bold">{props.StudentName}</p>
                <img className="w-[20px] h-[20px] rounded-full"
                 src={`${BaseUrl}/api/images/Student?url=${props.StudentImage}`}
                 alt="" />
            </div>
            {/* <div className="px-1 font-bold ">{props.Subject}</div> */}

            <div className="px-1 text-[14px] mt-1">
                {props.StartTime?.toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                })}{' '}
                -{' '}
                {props.EndTime?.toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                })}
            </div>
        </div>
      </>
    );
  };

  return (
    <div className="custom-schedule" style={{ overflowX: 'auto', width: '100%' }}>
        <ScheduleComponent
          rowAutoHeight={true}
          width={scheduleWidth} // 🔁 Dynamically adjusts
          // width="3000px" // Big width to allow cell expansion
          height="1500px"
          currentView="Week"
          timeFormat="hh:mm a"
          eventSettings={{
            dataSource: events,
            template: eventTemplate,
          }}
          eventRendered={onEventRendered}
        >
          <Inject services={[Day, Week]} />
        </ScheduleComponent>
    </div>
  );
};

export default AllLearnersSchedulerView;


 {/* <div className="p-2 flex flex-col">
        <div className="font-bold text-white">{props.Subject}</div>

        <div className="flex items-center gap-1 mt-1">
          {props.StudentImage && (
            <img
              src={props.StudentImage}
              alt="Student"
              className="w-5 h-5 rounded-full"
            />
          )}
          <span className="text-white text-sm">{props.StudentName}</span>
        </div>

        <div className="flex items-center gap-1">
          {props.InstructorImage && (
            <img
              src={props.InstructorImage}
              alt="Instructor"
              className="w-5 h-5 rounded-full"
            />
          )}
          <span className="text-white text-sm">{props.InstructorName}</span>
        </div>

        <div className="text-white text-xs mt-1">
          {props.StartTime?.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
          })}{' '}
          -{' '}
          {props.EndTime?.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </div>
      </div> */}
